import FirstArticleImage from './assets/first-article-image.webp';
import SecondArticleImage from './assets/second-article-image.webp';
import ThirdArticleImage from './assets/third-article-image.webp';

export const articlesBoxData = [
  {
    image: FirstArticleImage,
    articleUrl:
      'https://www.xing.com/news/articles/bewerbungs-trend-skill-gap-embrace-warum-sich-unternehmen-mit-weniger-qualifizierten-bewerbern-zufrieden-geben-5915715',
    thumbnail:
      'Bewerbungs-Trend „Skill Gap Embrace“: Warum sich Unternehmen mit weniger qualifizierten Bewerbern zufrieden geben',
    readingTime: '5 Minuten',
    section: 'articles-box',
  },
  {
    image: SecondArticleImage,
    articleUrl:
      'https://www.xing.com/news/articles/hor-auf-zu-warten-wie-dir-eine-uberzeugende-initiativbewerbung-in-3-schritten-gelingt-6004551',
    thumbnail:
      'Hör auf zu warten! Wie Dir eine überzeugende Initiativbewerbung in 3 Schritten gelingt',
    readingTime: '4 Minuten',
    section: 'articles-box',
  },
  {
    image: ThirdArticleImage,
    articleUrl:
      'https://www.xing.com/news/articles/finde-den-fehler-diese-bewerbungskiller-ubersiehst-du-immer-wieder-6136781',
    thumbnail:
      'Das war die letzte Absage! So wird Deine nächste Bewerbung eine Erfolgsstory',
    readingTime: '5 Minuten',
    section: 'articles-box',
  },
];

export const REGISTRATION_HEADLINE = 'Wusstest Du schon?';

export const REGISTRATION_BODY_TEXT =
  'XING kann Dich im gesamten Bewerbungsprozess unterstützen. Teste es doch mal kostenfrei aus.';

export const REGISTRATION_BUTTON = 'Jetzt Mitglied werden';
